// Forecast engine constants. These are calibrated multipliers — the forecast
// numbers depend on them, so change them deliberately.

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/**
 * Network day-of-week factors, indexed by JS getDay() (0=Sun .. 6=Sat).
 * Sum = 7, so a day's factor is its share relative to an average day
 * (e.g. Fri 1.18 = 18% above average; Sun 0.6 = 40% below).
 */
export const DAY_FACTORS = [0.6, 1.05, 1.12, 1.08, 1.15, 1.18, 0.82];

/**
 * Day-of-week shape per profile, indexed by getDay() (0=Sun..6=Sat), each
 * summing to ~7. "standard" uses the network factors.
 */
export const DOW_PROFILE_FACTORS: Record<string, number[]> = {
  standard: DAY_FACTORS,
  weekday: [0, 1.4, 1.4, 1.4, 1.4, 1.4, 0], // Mon–Fri only
  heavy_early: [0.4, 1.5, 1.5, 1.4, 0.9, 0.9, 0.4], // front-loaded Mon–Wed
  tue_thu: [0.3, 0.8, 1.6, 1.0, 1.6, 1.4, 0.3], // Tue/Thu peaks
};

/**
 * Seasonal factors by week-of-year (index 1..52; 0 unused).
 *  W1-4 slump · Q1 · Q2 ramp · summer · early peak · Thanksgiving · BFCM · Xmas.
 */
export const SEASONAL_FACTORS = (() => {
  const f = Array(53).fill(1.0);
  [1, 2, 3, 4].forEach((w) => (f[w] = 0.72));
  for (let w = 5; w <= 13; w++) f[w] = 0.9;
  for (let w = 14; w <= 21; w++) f[w] = 0.96;
  for (let w = 22; w <= 35; w++) f[w] = 0.93;
  for (let w = 36; w <= 43; w++) f[w] = 1.05;
  [44, 45, 46].forEach((w) => (f[w] = 1.3));
  [47, 48, 49, 50].forEach((w) => (f[w] = 1.55));
  [51, 52].forEach((w) => (f[w] = 1.6));
  return f;
})();

/** Federal-holiday multipliers keyed by "MM-DD"; a miss falls back to seasonal. */
export const HOLIDAY_TABLE: Record<string, number> = {
  "01-01": 0.28,
  "01-02": 0.55,
  "05-27": 0.5,
  "07-04": 0.38,
  "09-02": 0.48,
  "11-27": 0.22,
  "11-28": 2.8,
  "12-01": 2.6,
  "11-29": 1.8,
  "12-24": 0.35,
  "12-25": 0.15,
  "12-26": 1.1,
  "12-31": 0.5,
};
